import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"

import 'katex/dist/katex.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "./Styles/Fonts.css"



const rootElement = document.getElementById('root');
if (rootElement !== null) {

    const root = ReactDOM.createRoot(rootElement);

    root.render( <React.StrictMode >
        <BrowserRouter >
        <App / >
        </BrowserRouter>  
        </React.StrictMode>
    );

}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();